import {ReactNode, useState} from "react";
import ExpandCollapseArrow from "patient-ping-remedy/packages/expand-collapse-arrow";
import {Container, ExpandMoreButtonStyled} from "@common/timeline/ExpandMoreButton.styles";
import {colors} from "patient-ping-remedy/packages/theme";
import {css} from "@emotion/css";

type Props = {
  buttonText: string | ((isOpen: boolean) => string);
  buttonElement?: ReactNode;
  expandItems: ReactNode[];
  active: boolean;
  useExpandHideText: boolean;
  renderBelow?: boolean;
  inline?: boolean;
  disabled?: boolean;
  expandButtonWidth?: string
}

const ExpandMoreButton = (props: Props) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      {props.inline &&
        !isOpen && '...'
      }

      {!props.renderBelow &&
        isOpen && props.expandItems
      }

      <Container inline={props.inline}>
        <ExpandMoreButtonStyled
          active={props.active}
          inline={props.inline}
          disabled={props.disabled}
          data-expand-more
          onClick={() => setIsOpen(!isOpen)}
        >
          {!props.inline && !props.disabled && (
            <div className={css({ width: props.expandButtonWidth || 'auto' })}>
              <ExpandCollapseArrow
                isOpen={props.disabled ? true : !isOpen}
                iconSize={'1x'}
                iconColor={props.active ? colors.primary1 : colors.gray4}
              />
            </div>
          )}

          {props.useExpandHideText && (
            <>
              {isOpen ? 'Hide ' : 'Expand '}
              {typeof props.buttonText === 'string' ? props.buttonText : props.buttonText(isOpen)}
            </>
          )}

          {!props.useExpandHideText && (
            <>
              {typeof props.buttonText === 'string' ? props.buttonText : props.buttonText?.(isOpen)}
              {props.buttonElement ? props.buttonElement : null}
            </>
          )}
        </ExpandMoreButtonStyled>
      </Container>

      {props.renderBelow &&
        isOpen && props.expandItems
      }
    </>
  );
};

export default ExpandMoreButton;
